<template>
  <div class="auth-buttons">
    <button
      v-if="!isLoggedIn"
      @click="showLogin = true"
      class="auth-button login-button"
    >
      Login
    </button>
    <button
      v-if="!isLoggedIn"
      @click="showSignup = true"
      class="auth-button signup-button"
    >
      Sign Up
    </button>
    <div v-if="isLoggedIn" class="user-info">
      <router-link to="/user" class="profile-btn">
        <!-- User Icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        <span>Profile</span>
      </router-link>
      <button @click="handleLogout" class="logout-button">
        Logout
      </button>
    </div>

    <!-- Login Modal -->
    <div v-if="showLogin" class="modal-overlay" @click="showLogin = false">
      <div class="modal-content" @click.stop>
        <h3>Login</h3>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <input
              v-model="loginForm.email"
              type="email"
              placeholder="Email"
              required
              class="form-input"
            />
          </div>
          <div class="form-group">
            <input
              v-model="loginForm.password"
              type="password"
              placeholder="Password"
              required
              class="form-input"
            />
          </div>
          <div class="form-actions">
            <button type="submit" class="submit-button">Login</button>
            <button type="button" @click="showLogin = false" class="cancel-button">Cancel</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Signup Modal -->
    <div v-if="showSignup" class="modal-overlay" @click="showSignup = false">
      <div class="modal-content" @click.stop>
        <h3>Sign Up</h3>
        <form @submit.prevent="handleSignup">
          <div class="form-group">
            <input
              v-model="signupForm.email"
              type="email"
              placeholder="Email"
              required
              class="form-input"
            />
          </div>
          <div class="form-group">
            <input
              v-model="signupForm.password"
              type="password"
              placeholder="Password"
              required
              class="form-input"
            />
          </div>
          <div class="form-group">
            <input
              v-model="signupForm.confirm_password"
              type="password"
              placeholder="Confirm Password"
              required
              class="form-input"
            />
          </div>
          <div class="form-actions">
            <button type="submit" class="submit-button">Sign Up</button>
            <button type="button" @click="showSignup = false" class="cancel-button">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AuthButtons',
  data() {
    return {
      showLogin: false,
      showSignup: false,
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        email: '',
        password: '',
        confirm_password: ''
      }
    };
  },
  computed: {
    ...mapState(['isLoggedIn', 'user'])
  },
  methods: {
    ...mapActions(['login', 'signup', 'logout']),
    async handleLogin() {
      try {
        await this.login(this.loginForm);
        this.showLogin = false;
        this.loginForm = { email: '', password: '' };
      } catch (error) {
        console.error('Login failed:', error);
      }
    },
    async handleSignup() {
      try {
        await this.signup(this.signupForm);
        this.showSignup = false;
        this.signupForm = { email: '', password: '', confirm_password: '' };
      } catch (error) {
        console.error('Signup failed:', error);
      }
    },
    async handleLogout() {
      try {
        await this.logout();
      } catch (error) {
        console.error('Logout failed:', error);
      }
    }
  },
  watch: {
    '$store.state.isLoggedIn'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('auth-changed');
      }
    }
  }
};
</script>

<style scoped>
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.auth-button {
  padding: 10px 20px;
  border-radius: 4px; /* Sharp corners */
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

.login-button {
  background: transparent;
  color: #e4e4e7;
  border: 1px solid #3f3f46;
}

.login-button:hover {
  background: #27272a;
  border-color: #00dc82;
  color: #00dc82;
  transform: translateY(-2px);
  box-shadow: 0 4px 0 rgba(0, 220, 130, 0.2);
}

.signup-button {
  background: #00dc82;
  color: #000000;
  border: 1px solid #00dc82;
}

.signup-button:hover {
  background: #10b981;
  border-color: #10b981;
  transform: translateY(-2px);
  box-shadow: 0 4px 0 #047857;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #f3f4f6;
}

.profile-btn {
  background: transparent;
  color: #00dc82;
  border: 1px solid #00dc82;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.profile-btn:hover {
  background: rgba(0, 220, 130, 0.1);
  color: #00dc82;
}

.logout-button {
  background: transparent;
  color: #ef4444;
  border: 1px solid #ef4444;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  font-weight: 600;
}

.logout-button:hover {
  background: #ef4444;
  color: white;
  transform: translateY(-1px);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.modal-content {
  background: #18181b;
  border: 1px solid #27272a;
  border-radius: 4px;
  padding: 32px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-content h3 {
  color: #f3f4f6;
  margin-bottom: 24px;
  text-align: center;
  text-transform: uppercase;
  font-size: 1.5rem;
  letter-spacing: 1px;
}

.form-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  background: #09090b;
  border: 1px solid #3f3f46;
  border-radius: 4px;
  box-sizing: border-box;
  color: #f3f4f6;
  font-size: 1rem;
  transition: all 0.2s ease;
  font-family: inherit;
}

.form-input:focus {
  outline: none;
  border-color: #00dc82;
  box-shadow: 0 0 0 1px #00dc82;
}

.form-input::placeholder {
  color: #52525b;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background: #00dc82;
  color: #000000;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.submit-button:hover {
  background: #10b981;
  transform: translateY(-2px);
  box-shadow: 0 4px 0 #047857;
}

.submit-button:active {
  transform: translateY(0);
  box-shadow: none;
}

.cancel-button {
  width: 100%;
  padding: 12px;
  background: transparent;
  color: #71717a;
  border: 1px solid transparent;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.cancel-button:hover {
  color: #e4e4e7;
  border-color: #3f3f46;
}

@media (max-width: 768px) {
  .auth-buttons {
    gap: 8px;
  }

  .auth-button {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .modal-content {
    padding: 24px;
    margin: 20px;
  }
}
</style>
